/**
 * Post Tabs Listener
 *
 * Registers and cleans up event listeners for post tab interactions.
 */

import { PostSharedTabsHandler } from "./post-tabs-handler";
import { postTabsForm } from "./post-tabs-form";

const tabClickHandlers = new WeakMap<Element, EventListener>();

interface SetupPostTabSwitchingParams {
    rootEl: Document | HTMLElement;
    onPreview: () => void;
}

class PostSharedTabsListener {
    public static setupPostTabSwitching(params: SetupPostTabSwitchingParams): void {
        const { rootEl, onPreview } = params;

        const tabs = postTabsForm.getTabs(rootEl);
        const panels = postTabsForm.getPanels(rootEl);

        if (!tabs || tabs.length === 0) return;

        tabs.forEach((tab) => {
            const existingHandler = tabClickHandlers.get(tab);
            if (existingHandler) {
                tab.removeEventListener("click", existingHandler);
            }

            const tabClickHandler = PostSharedTabsHandler.createTabClickHandler({
                tab,
                tabs,
                panels,
                rootEl,
                onPreview,
            });

            tabClickHandlers.set(tab, tabClickHandler);
            tab.addEventListener("click", tabClickHandler);
        });
    }

    public static cleanupPostTabSwitching(rootEl: Document | HTMLElement = document): void {
        const tabs = postTabsForm.getTabs(rootEl);
        tabs.forEach((tab) => {
            const existingHandler = tabClickHandlers.get(tab);
            if (!existingHandler) return;
            tab.removeEventListener("click", existingHandler);
            tabClickHandlers.delete(tab);
        });
    }
}

export { PostSharedTabsListener };
